export default __webpack_public_path__ + "static/media/Screenshot_15.4ca9e3c9.png";